var _desc, _defs, _ellipse, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _ellipse2, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 360",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Nuvvy character talking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A friendly Nuvvy cafe character talking.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "body",
    x1: 70,
    y1: 55,
    x2: 250,
    y2: 290,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2f5741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#173525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cream",
    x1: 80,
    y1: 20,
    x2: 240,
    y2: 280,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaf7b5"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160,
    cy: 315,
    rx: 86,
    ry: 16,
    fill: "#102e06",
    opacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 162c0-59 35-103 78-103s78 44 78 103v70c0 51-35 82-78 82s-78-31-78-82z",
    fill: "url(#body)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 121c4-43 25-75 52-75s48 32 52 75c-13-18-30-27-52-27s-39 9-52 27z",
    fill: "url(#cream)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128 137c0-25 14-45 32-45s32 20 32 45c0 13-5 25-13 33l-19-58-19 58c-8-8-13-20-13-33z",
    fill: "#2f5741"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 177,
    r: 9,
    fill: "#fffbe8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 177,
    r: 9,
    fill: "#fffbe8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 178,
    r: 3,
    fill: "#173525"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 178,
    r: 3,
    fill: "#173525"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160,
    cy: 217,
    rx: 22,
    ry: 13,
    fill: "#fffbe8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92 196c-26 7-43 23-45 47",
    fill: "none",
    stroke: "#2f5741",
    strokeWidth: 22,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M228 196c26 7 43 23 45 47",
    fill: "none",
    stroke: "#2f5741",
    strokeWidth: 22,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103 265c25 27 89 27 114 0",
    fill: "none",
    stroke: "#fffbe8",
    strokeWidth: 12,
    strokeLinecap: "round",
    opacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalking);
export default __webpack_public_path__ + "static/media/talking.3c7f5ff553e31bca5d68ec933ca99adf.svg";
export { ForwardRef as ReactComponent };